import type { Project } from '@rcs/data-schema';
import { useEffect, useState } from 'react';
import { App } from './App';
import { createSampleProject } from './project/sample';
import { createIndexedDbStore, requestPersistence, restoreProject } from './storage/project-store';

interface Booted {
  readonly project: Project;
  readonly notice: string | undefined;
}

/**
 * 起動処理：永続ストレージを要求し、前回のプロジェクトを復元してからアプリを表示する（FR-CRS-003）。
 * 保存データがなければサンプルプロジェクトで始める。URL の `?course=` を指定したときは、画面確認用の
 * 仮のコースを使うため、復元しない。
 */
export function Boot() {
  const [store] = useState(() => createIndexedDbStore());
  const [booted, setBooted] = useState<Booted | undefined>();
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      void requestPersistence();
      const fixture = new URLSearchParams(window.location.search).has('course');
      const result = fixture ? { status: 'empty' as const } : await restoreProject(store);
      if (cancelled) return;
      if (result.status === 'restored') {
        setBooted({ project: result.project, notice: undefined });
      } else {
        setBooted({
          project: createSampleProject(new Date().toISOString()),
          notice: result.status === 'failed' ? result.message : undefined,
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [store]);
  if (!booted) return <div className="boot" data-testid="boot" aria-busy="true" />;
  return <App initialProject={booted.project} store={store} restoreError={booted.notice} />;
}
